const defaultHeader = {
  'Content-Type': 'application/json',
  'Accept-Language': 'de',
};

export const checkStatus = async (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(response.statusText);
    const data = await response.json();
    // @ts-ignore
    error.response = response;
    // @ts-ignore
    error.response.data = data;
    throw error;
  }
};

const parseJSON = (response: Response) => response.json();

export const request = <T>(url: string, config: RequestInit): Promise<T> =>
  fetch(url, config)
    .then(checkStatus)
    .then(parseJSON);

export const get = <T>(url: string, headers?: Headers): Promise<T> => {
  return request<T>(url, {
    method: 'GET',
    credentials: 'include',
    headers: headers ? { ...defaultHeader, ...headers } : defaultHeader,
  });
};

export const post = <T>(url: string, data: { [k: string]: any }, headers?: Headers): Promise<T> => {
  return request<T>(url, {
    method: 'POST',
    credentials: 'include',
    headers: headers ? { ...defaultHeader, ...headers } : defaultHeader,
    body: JSON.stringify(data),
  });
};

export const put = <T>(url: string, data: { [k: string]: any }, headers?: Headers): Promise<T> => {
  return request<T>(url, {
    method: 'PUT',
    credentials: 'include',
    headers: headers ? { ...defaultHeader, ...headers } : defaultHeader,
    body: JSON.stringify(data),
  });
};

export const deleteRequest = <T>(url: string, headers?: Headers) => {
  return request<T>(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: headers ? { ...defaultHeader, ...headers } : defaultHeader,
  });
};

export const switchRequestDefaultLanguage = (lang: string) => {
  defaultHeader['Accept-Language'] = lang;
};
